<template>
	<main class="main">
		<section class="vacancy-desc pt-0">
			<div class="position-relative">
				<div class="container pt-3 position-relative">
					<div class="row justify-content-center align-items-end mb-0">
						<div class="col-md-10">
							<div class="align-items-center">
								<h2>{{task.label}}</h2>
								<div class="form-group">
									<label class="control-label mb-2">
										Вопросы:
									</label>
									<template v-for="(item, index) in task.questions">
										<div class="form-group">
											<template v-if="item.type === 0">
												<label class="checkbox mr-2">
													<input type="checkbox"
															:name="'q[' + index + ']'"
															:value=index
															v-model="form.questions[index]"
													>
													<span class="checkbox__circle"></span>
													<span>{{item.label}}</span>
												</label>
											</template>
											<template v-else-if="item.type === 1">
												<label class="control-label">{{item.label}}</label>
												<b-form-file
														:name="'q[' + index + ']'"
														placeholder="Выберите файл..."
														drop-placeholder="Перенесите файл сюда..."
														browse-text="Обзор"
														v-model="form.questions[index]"
												/>
											</template>
											<template v-else-if="item.type === 2">
												<label class="control-label">{{item.label}}</label>
												<input type="text"
														class="form-control"
														:name="'q[' + index + ']'"
														v-model="form.questions[index]"
												>
											</template>
										</div>
									</template>
								</div>
								<div class="form-row mt-1 align-items-center">
									<div class="col-3">
										<button type="submit" class="btn btn-secondary" @click.prevent="validateBeforeSubmit">
											Сохранить
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
	import {mapGetters, mapActions} from "vuex";

	export default {
		name: "TaskView",
		components: {},
		props: [
			'id'
		],
		data() {
			return {
				task: {},
				form: {
					questions: [],
				},
			}
		},
		methods: {
			...mapActions({
				getTask: 'task/TASK',
				answerTask: 'task/TASK_ANSWER'
			}),
			validateBeforeSubmit() {
				this.$validator.validateAll().then((result) => {
					if (result) {
						let dataSend = {};
						let formData = new FormData;
						for (let v in this.value) {
							if (this.value[v]) {
								formData.append(v, this.value[v]);
							}
						}

						this.answerTask(this.form.questions)
							.then(res => {
								if (res.ok) {
									this.$router.push({name: 'tasks'});
								} else {
									this.err = res.body.error;
								}
							});
					}
				});
			},
		},
		created() {
			this.getTask(this.id).then(r => {
				this.task = r.body;
			});
		}
	}
</script>

<style scoped>
	.ymap-container {
		padding: 0;
	}
</style>
